/**
 * Кортеж, представляющий собой два разницу двух массивов
 * Первый элемент - массив элементов, существующих в первом массиве, но не существующих во втором.
 * Второй элемент - массив элементов, существующих во втором массиве, но не существующих в первом.
 */
export type ArrayDiffTuple<Arr = unknown> = [missingInFirstArr: Arr[], missingInSecondArr: Arr[]];

/**
 * Находит разницу двух массивов.
 *
 * @template Arr - Тип элементов в массиве
 * @param {Arr[]} firstArray - первый массив для сравнения
 * @param {Arr[]} secondArray - второй массив для сравнения
 * @returns {ArrayDiffTuple<Arr>}
 * @example
 * const [ diffFirst, diffSecond ] = findArraysDifference([ 1, 2, 3 ], [ 1, 2, 4, 5 ]);
 * console.log(diffFirst) // [ 4, 5 ]
 * console.log(diffSecond) // [ 3 ];
 */
export const findArraysDifference = <Arr = unknown>(firstArray: Arr[], secondArray: Arr[]): ArrayDiffTuple<Arr> => {
    const firstArraySet = new Set(firstArray);
    const secondArraySet = new Set(secondArray);
    const missingInFirstArray = secondArray.filter(it => !firstArraySet.has(it));
    const missingInSecondArray = firstArray.filter(it => !secondArraySet.has(it));

    // очищаем хранилища, не дожидаясь garbage collector
    firstArraySet.clear();
    secondArraySet.clear();

    return [ missingInFirstArray, missingInSecondArray ];
};
